/*
 * @Author: ylq
 * @Date: 2022-09-20 16:05:55
 * @Desc: 路由基本规则
 * @Last Modified by: ylq
 * @Last Modified time: 2025-11-07 17:36:13
 */
import { isLogin, clearToken } from '@/utils/auth';
import { useUserStore } from '@/store';
import usePermission from '@/hooks/permission';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import i18n from '@/locales';
import router from '@/router';
import CONFIG from '@/config/config';
import { tools } from '@/utils/tools';
import { appRoutes } from '../routes';
import { getKey } from '@/utils/authkey';
import { performance, catchError } from '@/utils/sky-walking';
// import dayjs from 'dayjs';
// import useVolLog from '@/hooks/vol-log';
// const track = useVolLog();
let isAddCustom = false;
function getNeedAdd(data) {
  //新增自定义对象
  data.forEach((item) => {
    if (item?.entity >= 200) {
      const _custom = [];
      item?.children?.forEach((ic) => {
        _custom.push(ic.code);
      });
      if (_custom.length > 0) {
        addCustomRouter(item, _custom);
      }
    }
  });
  //新增点位菜单
  const userStore = useUserStore();
  if (userStore?.userInfo?.menus?.menuVos?.length) {
    const getRouterObj = (cpc) => {
      return {
        path: `customPage${cpc?.business}`,
        name: `customPage${cpc?.business}`,
        component: () => import('@/views/frame/frame.vue'),
        props: {
          pcUrl: cpc?.resource?.pcUrl
        },
        meta: {
          roles: `customPage:${cpc?.business}`,
          title: data?.title,
          hideChildrenInMenu: true,
          openWith: cpc?.resource?.openWith
        },
        children: []
      };
    };
    const _cpRouters = [];
    userStore?.userInfo?.menus?.menuVos?.map((cpc) => {
      if (cpc?.group) {
        if (cpc?.child?.length) {
          cpc?.child?.map((cpcc) => {
            if (cpcc?.type === '40' && cpcc?.resource?.pcUrl) {
              const _cpRouter = getRouterObj(cpcc);
              router.addRoute('frame', _cpRouter);
              _cpRouters.push(_cpRouter);
            }
          });
        }
      } else {
        if (cpc?.type === '40' && cpc?.resource?.pcUrl) {
          const _cpRouter = getRouterObj(cpc);
          router.addRoute('frame', _cpRouter);
          _cpRouters.push(_cpRouter);
        }
      }
    });
    router.options.routes.map((ror) => {
      if (ror.name == 'frame') {
        ror.children = _cpRouters;
      }
    });
  }
}
function addCustomRouter(data, roles) {
  const _route = {
    path: `${data.entity}:entity`,
    name: `custom:${data.entity}`,
    component: () => import('@/layout/page.vue'),
    redirect: { name: `${data.entity}:view` },
    meta: {
      roles: data.entity,
      title: data?.title,
      hideChildrenInMenu: true,
      entity: data.entity
    },
    children: []
  };

  roles.map((role) => {
    if (role == `${data.entity}:view`) {
      const _view = {
        path: '',
        name: role,
        meta: { roles: role, title: '' },
        component: () => import('@/views/sys-obj/sys-obj.vue'),
        props: { entity: data.entity }
      };
      _route.children.push(_view);
      const _detail = {
        path: ':id',
        name: `${data.entity}:detail`,
        meta: { roles: role, title: '' },
        component: () => import('@/views/sys-obj/sys-obj.vue'),
        props: { entity: data.entity }
      };
      _route.children.push(_detail);
      //兼容移动端自定义对象协作人
      const _collaborators = {
        path: ':id/collaborators',
        name: `${data.entity}:collaborators`,
        meta: { roles: role, title: '' },
        component: () => import('@/views/sys-obj/sys-obj.vue'),
        props: { entity: data.entity }
      };
      _route.children.push(_collaborators);
    }
    // else if (role == `${data.entity}:add`) {
    //   const _add = {
    //     path: ':type-:viewId-:entity',
    //     name: role,
    //     meta: { roles: role, title: '' },
    //     component: () => import('@/views/custom/custom-update/custom-update.vue')
    //   };
    //   _route.children.push(_add);
    // } else if (role == `${data.entity}:copy`) {
    //   const _add = {
    //     path: ':id-:type-:viewId-:entity-:copy',
    //     name: role,
    //     meta: { roles: role, title: '' },
    //     component: () => import('@/views/custom/custom-update/custom-update.vue')
    //   };
    //   _route.children.push(_add);
    // } else if (role == `${data.entity}:edit`) {
    //   const _edit = {
    //     path: ':id-:type-:viewId-:entity',
    //     name: role,
    //     meta: { roles: role, title: '' },
    //     component: () => import('@/views/custom/custom-update/custom-update.vue')
    //   };
    //   _route.children.push(_edit);
    // }
  });
  // console.log(92, _route, 3456789, 0, router.options.routes);
  const findCustom = router.options.routes.find((el) => el.name === 'custom');
  if (!findCustom?.children?.find((el) => el.name === _route.name)) {
    router.addRoute('custom', _route);
    router.options.routes.map((ror) => {
      if (ror.name == 'custom') {
        ror.children.push(_route);
      }
    });
    // findCustom.children.push(_route);
  }
}
function setupGuard(router) {
  // 路由守卫
  router.beforeEach(async (to, from, next) => {
    const { t } = i18n.global;
    // const memory = window.performance?.memory;
    // const totalJSHeapSize = memory ? parseInt(memory?.totalJSHeapSize / 1024 / 1024) : 0;
    // const usedJSHeapSize = memory ? parseInt(memory?.usedJSHeapSize / 1024 / 1024) : 0;
    // console.log(1766611, memory, totalJSHeapSize, usedJSHeapSize);
    // console.log(1766611, memory.totalJSHeapSize / 1024 / 1024, memory.usedJSHeapSize / 1024 / 1024, memory.jsHeapSizeLimit / 1024 / 1024);
    // 判断新key是否等于cookie中的key
    const tq = to.query;
    let newKey = null;
    if (tq?.key && tq?.skey && tq.key !== '' && tq?.skey !== '') {
      newKey = `${tq?.key}|${tq?.skey}`;
    } else if (tq?.key && tq?.key !== '' && (!tq?.skey || tq?.skey === '')) {
      newKey = `${tq?.key}`;
    }
    const oldKey = window.unescape(tools.getCookie(CONFIG.KEY)); //返回一个对象大小key{key:'',skey:''}
    if (((tq?.key && !tq?.skey) || (tq?.key && tq?.skey)) && newKey !== oldKey) {
      // 如果新key不等于cookie中的key，那么就更新cookie中的key
      tools.setCookie(CONFIG.KEY, newKey, 365);
      clearToken();
    }

    // 修改query
    if (!tq.key || !tq?.skey) {
      const keySkey = getKey();
      if (keySkey.key != 'isv_primary') {
        to.query = { ...to.query, key: keySkey?.key || '', skey: keySkey?.skey || '' };
      }
    }
    // 2024-09-06 ylq 增加来源key和当前key不一致，则刷新当前页面。
    console.log(`1100110101`, from, from.query, window.unescape(tools.getCookie(CONFIG.KEY)));
    const fromQuery = from.query;
    let formKey = null;
    if (fromQuery?.key && fromQuery?.skey && fromQuery.key !== '' && fromQuery?.skey !== '') {
      formKey = `${fromQuery?.key}|${fromQuery?.skey}`;
    } else if (fromQuery?.key && fromQuery?.key !== '' && (!fromQuery?.skey || fromQuery?.skey === '')) {
      formKey = `${fromQuery?.key}`;
    }
    if (fromQuery?.key && fromQuery?.skey && formKey !== oldKey) {
      console.log(`1100110101128`, fromQuery.key, fromQuery.skey, oldKey);
      const { key, skey } = getKey();
      window.location.href = `${location.origin}?key=${key}&skey=${skey}`;
      // return;
    }
    // 2024-09-06 ylq 增加来源key和当前key不一致，则刷新当前页面。

    const loginPath = {
      name: 'login',
      query: {
        redirect: to.path,
        ...to.query
      }
    };
    NProgress.start();
    const userStore = useUserStore();
    // 要排查的等级，从后往前排
    const level = 0;
    // if(to.matched[0]?.meta?.single){
    //   level = 0;
    // }
    // 增加内存相关报告 ylq 2024-12-06

    const modeLists = ['production', 'pc2', 'matrixProd', 'kaixian'];
    const mode = import.meta.env.MODE;
    if (modeLists.includes(mode)) {
      // 任意组件中访问版本信息
      // const version = __APP_VERSION__;
      // track.send({
      //   type: 'memory',
      //   totalJSHeapSize,
      //   usedJSHeapSize,
      //   page: window.location.href,
      //   orgName: userStore.userInfo?.orgName || '-',
      //   userName: userStore.userInfo?.userName || '-',
      //   orgId: userStore.userInfo?.orgId || '-',
      //   userId: userStore.userInfo?.id || '-',
      //   fromPage: from.fullPath,
      //   feishu: !!window.h5sdk,
      //   version,
      //   time: dayjs().format('YYYY-MM-DD HH:mm:ss')
      // });
    }
    async function checkRouter() {
      const Permission = usePermission();
      if (Permission.accessRouter(to)) {
        if (to.query.rt) {
          delete to.query.rt;
          const nTo = {
            name: to.name,
            path: to.path,
            query: to.query,
            params: to.params
          };
          await next(nTo);
        } else {
          console.log(170, to);
          await next();
        }
      } else {
        let destination = undefined;
        // 逐级往上级找可用。
        for (let index = to.matched.length - 1; index >= 0; index--) {
          const ele = to.matched[index];
          if (destination) break;
          if (index === level) {
            destination = Permission.findFirstPermissionRoute(ele?.children, userStore?.userInfo?.roles);
            break;
          }
          if (index >= level && !destination) {
            destination = Permission.findFirstPermissionRoute(ele?.children, userStore?.userInfo?.roles);
          }
        }
        console.log(1777777, 170, destination, appRoutes, to, userStore?.userInfo.menus, 'userStore?.userInfo?.roles');
        // 如果上面都没有，那就返回404
        if (!destination) {
          destination = Permission.findFirstPermissionRoute(appRoutes, userStore?.userInfo?.roles, userStore?.userInfo?.menuVosFlat) || {
            name: 'notAccess',
            query: { ...to.query, path: to.path }
          };
        }
        console.log(1777777, 170, destination);
        // 鉴权时如果只有设置页面时，跳转到无权限
        let haveRouterPage = false; // 假设没有其他路由权限
        haveRouterPage = (userStore?.userInfo?.menus?.builtIns?.length && userStore?.userInfo?.menus?.builtIns?.some((item) => item.code !== 'settings')) || userStore?.userInfo?.menus?.entityResources?.length;
        if (userStore?.userInfo?.orgId !== 3 && !haveRouterPage) {
          console.log(to.query);
          destination = {
            name: 'notAccess',
            query: { ...to.query, path: to.path }
          };
        }
        console.log(170021, destination);
        // const m = to.matched[to.matched.length - 2];// m?.children,
        // const single = to.matched[0]?.meta?.single;
        // destination = Permission.findFirstPermissionRoute((single && to.matched[1]?.children) || m?.children || appRoutes, userStore?.userInfo?.roles);
        // 处理query
        let q = { ...to.query };
        if (destination.query) {
          q = { ...destination.query, ...to.query };
        }
        // 这里是自定义字段的特殊逻辑
        if (destination.name.indexOf('custom:') === 0) {
          const entityId = destination.name.split(':')?.[1];
          console.log(170022, destination, entityId);
          await next({ name: destination.name, params: { entity: entityId }, query: q, replace: true });
          // 这里是自定义字段的特殊逻辑
        } else {
          await next({ ...destination, query: q });
        }
      }
      NProgress.done();
    }
    const levelRole = userStore?.userInfo && userStore?.userInfo?.menuObj[to.meta?.roles];
    document.title = levelRole || (to.meta?.title ? t(to.meta.title) : '烽火Matrix');
    // 检查用户是否已登录
    if (isLogin()) {
      if (userStore.userInfo) {
        console.log(25455);
        //处理自定义对象路由
        if (userStore?.userInfo?.menus?.entityResources?.length) {
          getNeedAdd(userStore?.userInfo?.menus?.entityResources);
        }
        if (!isAddCustom) {
          console.log(25455, 1);
          isAddCustom = true;
          next({ path: to.path, query: { ...to.query }, replace: true });
        } else {
          console.log(25455, 22);
          checkRouter();
        }
        // checkRouter();
      } else {
        try {
          await userStore.getUserinfo();
          // if (!isAddCustom) {
          //处理自定义对象路由
          if (userStore?.userInfo?.menus?.entityResources?.length) {
            getNeedAdd(userStore?.userInfo?.menus?.entityResources);
          }
          console.log(
            25455,
            3456789,
            router.options.routes,
            router.options.routes.find((el) => el.name === 'custom')
          );
          // isAddCustom = true;
          // checkRouter();
          console.log(25455, 256, to);
          next({ path: to.path, query: { ...to.query }, replace: true });
          // } else {
          // checkRouter();
          // }
        } catch (error) {
          console.log('123-4', error, userStore.userInfo);
          // await userStore.logout();
          next(loginPath);
        }
      }

      NProgress.done();
    } else {
      // 避免无限重定向 'notAccess'
      const whiteList = ['login', 'notAccess', 'otherErrors'];
      if (whiteList.includes(to.name)) {
        next();
        NProgress.done();
        return;
      }
      // 将用户重定向到登录页面
      next(loginPath);
      NProgress.done();
    }
  });

  router.beforeResolve(async (to) => {
    console.log(to, '解析');
  });
  router.afterEach((to, from) => {
    console.log(24222, to, from);
    performance();
  });
  router.onError((error) => {
    // 在这里处理路由错误
    console.log('222333捕获到路由错误:', error);
    // 上报错误信息的逻辑（例如，发送到错误监控平台）
    catchError(error);
  });
}
export default function routeGuard(router) {
  setupGuard(router);
}
